/**
 * LeadScoreBadge Component
 * Visual indicator for lead temperature
 */

import React from 'react';

const LeadScoreBadge = ({ score, temperature, size = 'sm' }) => {
  const colors = {
    hot: 'bg-orange-500/15 text-orange-600 dark:text-orange-400',
    warm: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
    cold: 'bg-blue-500/15 text-blue-600 dark:text-blue-400'
  };

  const dotColors = {
    hot: 'bg-orange-500',
    warm: 'bg-amber-500',
    cold: 'bg-blue-500'
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[11px]',
    md: 'px-2.5 py-1 text-[12px]',
    lg: 'px-3 py-1.5 text-[13px]'
  };

  return (
    <div className={`inline-flex items-center gap-1.5 rounded-full font-medium
      ${colors[temperature] || colors.cold} ${sizeClasses[size]}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotColors[temperature] || dotColors.cold}
        ${temperature === 'hot' ? 'animate-pulse' : ''}`}
      />
      <span className="capitalize">{temperature}</span>
      {score !== undefined && (
        <span className="opacity-60">{score}</span>
      )}
    </div>
  );
};

export default LeadScoreBadge;
